import React from "react";
import { Check } from "lucide-react";
import { LANDING } from "@/constants/testIds";

const items = [
  "You want more customers walking through your doors",
  "You want more calls, bookings, or inquiries",
  "You want more people finding your business online",
  "You want to stand out from competitors during the Finals",
  "You want to take advantage of the increased traffic and excitement around the Spurs",
  "You want a simple, affordable way to attract more business right now",
];

const ReadyToWin = () => {
  return (
    <section
      data-testid={LANDING.readyToWinSection}
      className="px-4 md:px-8 my-12 md:my-20"
    >
      <div className="bg-[#0A0A0A] text-white rounded-[2rem] md:rounded-[3rem] mx-auto max-w-7xl py-20 md:py-28 px-6 md:px-16 relative overflow-hidden">
        {/* Accent glows */}
        <div className="pointer-events-none absolute -top-32 -left-32 w-[400px] h-[400px] rounded-full bg-[#EF426F]/20 blur-3xl" />
        <div className="pointer-events-none absolute -bottom-32 -right-32 w-[400px] h-[400px] rounded-full bg-[#00B2A9]/20 blur-3xl" />

        <div className="relative">
          <p className="text-xs md:text-sm font-bold uppercase tracking-[0.25em] text-[#FF8200] mb-4">
            Who's Ready To Win
          </p>
          <h2 className="text-4xl md:text-6xl font-black tracking-tighter leading-[0.95] max-w-4xl">
            Whether you're serving fans or capitalizing on{" "}
            <span className="bg-gradient-to-r from-[#00B2A9] via-[#EF426F] to-[#FF8200] text-transparent bg-clip-text">
              the spotlight
            </span>{" "}
            — this is for you.
          </h2>

          <p className="mt-8 text-base md:text-lg text-zinc-300 leading-relaxed max-w-3xl">
            This package was built for businesses that want to turn visibility into
            revenue while the city is in the spotlight. This is especially for you if:
          </p>

          <ul className="mt-10 grid grid-cols-1 md:grid-cols-2 gap-x-10 gap-y-5">
            {items.map((it, i) => (
              <li key={i} className="flex items-start gap-3">
                <span className="mt-1 shrink-0 w-6 h-6 rounded-full bg-gradient-to-br from-[#00B2A9] to-[#FF8200] flex items-center justify-center">
                  <Check size={14} strokeWidth={3} className="text-white" />
                </span>
                <span className="text-base md:text-lg font-medium text-white/90 leading-snug">
                  {it}
                </span>
              </li>
            ))}
          </ul>

          <p className="mt-12 text-lg md:text-xl font-bold text-white max-w-3xl leading-snug">
            If more visibility, customers, bookings, or sales would help your business
            grow during the Spurs Finals,{" "}
            <span className="bg-gradient-to-r from-[#00B2A9] via-[#EF426F] to-[#FF8200] text-transparent bg-clip-text">
              this package is for you.
            </span>
          </p>
        </div>
      </div>
    </section>
  );
};

export default ReadyToWin;
